import React from "react"
import { Link, graphql } from "gatsby"
import { GatsbyImage, getImage } from "gatsby-plugin-image"
import { motion } from "framer-motion"
import { BsCalendar3 } from "react-icons/bs"
import { AiFillTag } from "react-icons/ai"

const ArticleCard = ({ article }) => {
  var options = {
    year: "numeric",
    month: "long",
    day: "numeric",
  }

  const opacity = {
    offScreen: { opacity: 0 },
    onScreen: {
      opacity: 1,
      transition: { type: "spring", bounce: 0.4, duration: 2 },
    },
  }

  return (
    // <motion.div
    //   variants={opacity}
    //   initial={"offScreen"}
    //   whileInView={"onScreen"}
    //   transition={{ staggerChildren: 0.2 }}
    //   key={article.id}
    //   className="testimonial_card"
    // >
    //   <Link to={`/blog/${article.slug}`}>
    //     <div className="testimonial_image">
    //       <GatsbyImage
    //         image={getImage(article.cover?.localFile)}
    //         alt={article.cover?.alternativeText}
    //       />
    //     </div>
    //   </Link>
    //   <div className="blog-text">
    //     <p>
    //       Publicado:
    //       {new Date(article.date)?.toLocaleDateString("en-US", options)}
    //     </p>
    //     <Link to={`/blog/${article.slug}`}>
    //       <h2>{article.title}</h2>
    //     </Link>
    //     <h3>{article.description}</h3>
    //     <Link key={article.id} to={`/blog/${article.slug}`}>
    //       <button>Leer Más</button>
    //     </Link>
    //   </div>
    // </motion.div>

    <motion.div
      variants={opacity}
      initial={"offScreen"}
      whileInView={"onScreen"}
      transition={{ staggerChildren: 0.2 }}
      key={article.id}
      className="testimonial_card"
    >
      <Link to={`/blog/${article.slug}`}>
        <div className="testimonial_image">
          <GatsbyImage
            image={getImage(article.cover?.localFile)}
            alt={article.cover?.alternativeText}
          />
        </div>
      </Link>
      <div className="testimonial_card_position">
        <Link to={`/blog/${article.slug}`}>
          <h3>{article.title}</h3>
        </Link>
        <p>{article.description}</p>
        <div className="ref">
          <Link to={`/blog/${article.slug}`}>
            <div className="button">Leer más</div>
          </Link>
        </div>
        <div className="testiminail_text_footer">
          <div className="testiminail_text_footer_center">
            <AiFillTag className="testiminail_text_footer_icon" />
            <p>Tag</p>
          </div>
          <div
            className="testiminail_text_footer_center"
            style={{ display: "flex", justifyContent: "end" }}
          >
            <BsCalendar3 className="testiminail_text_footer_icon" />
            <p>{new Date(article.date)?.toLocaleDateString("en-US", options)}</p>
          </div>
        </div>
      </div>
    </motion.div>
  )
}

export const query = graphql`
  fragment ArticleCard on STRAPI_ARTICLE {
    id
    slug
    title
    description
    cover {
      caption
      alternativeText
      localFile {
        childImageSharp {
          gatsbyImageData(layout: FULL_WIDTH)
        }
      }
    }
  }
`

export default ArticleCard
